const ActionTypes = {
  LOAD_RSA_KEYS: "LOAD_RSA_KEYS",
  SIGN_IN: "SIGN_IN",
  SIGN_UP: "SIGN_UP",
  LOAD_USER_LOCAL_STATE: "LOAD_USER_LOCAL_STATE",
  UPDATE_CONTACTS: "UPDATE_CONTACTS",
  SET_RECEIVER: "SET_RECEIVER",
  LOGOUT: "LOGOUT",
  NEW_MESSAGE: "NEW_MESSAGE",
  SEND_NEW_MESSAGE: "SEND_NEW_MESSAGE",
  SET_ACK_FLAG: "SET_ACK_FLAG",
};

export default ActionTypes;
